import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import Badge from '@material-ui/core/Badge';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import ShoppingCartIcon from '@material-ui/icons/ShoppingCart';

import { AuthCtx } from 'components/auth/auth-ctx';

import { OrderCtx } from './order-ctx';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    cartWrapper: {
      padding: '0px 5px',
    },
    link: {
      display: 'flex',
      alignItems: 'center',
    },
    iconWrapper: {
      color: theme.palette.secondary.main,
      fontSize: '1.8rem',
    },
  })
);

export function CartHeader() {
  const classes = useStyles();
  const { userInfo } = useContext(AuthCtx);
  const { archivalUnits } = useContext(OrderCtx);

  return (
    <div className={classes.cartWrapper}>
      {userInfo && !!archivalUnits?.length && (
        <Badge badgeContent={archivalUnits?.length} color="primary">
          <Link to="/portfolio/vytvoreni-objednavky" className={classes.link}>
            <ShoppingCartIcon className={classes.iconWrapper} />
          </Link>
        </Badge>
      )}
    </div>
  );
}
